import { StepperOrientation } from "@angular/cdk/stepper";
import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { IMyDateModel, IAngularMyDpOptions } from "angular-mydatepicker";
import { PaymentService, ErrorHandlerService, ValidDatePipe, ViewportService, CommonSettings, ConfirmDialogModel, ConfirmDialogComponent } from "epay-library";
import { IPaymentAccount } from "epay-library/lib/features/common/models/payment/paymentaccount";
import { IScheduledDay } from "epay-library/lib/features/common/models/payment/scheduledday";
import { IScheduledFrequency } from "epay-library/lib/features/common/models/payment/scheduledfrequency";
import { IEMPPayment } from "epay-library/lib/features/employer/models/payment/achd/employerPayment";
import { IEMPPaymentList } from "epay-library/lib/features/employer/models/payment/achd/employerPaymentList";
import { IEMPPaymentCollection } from "epay-library/lib/features/employer/models/payment/employerPaymentCollection";
import * as XLSX from 'xlsx';


const PayorValidationTypes = {
  scheduldedPayment: 'scheduledPayment',
  creditCard: 'creditCard',
  eftEdiFile: 'eftEdiFile',
};

type AOA = any[][];

enum PrenoteStatus {
  Failed = '3',
  Prenote = '2',
  Active = '1',
}

@Component({
  selector: 'epay-employer-payment',
  templateUrl: './epay-employer-payment.component.html',
})
export class EpayEmployerPaymentComponent implements OnInit {
  @Input() baseurl = '';
  @Input() clientName = '';
  @Input() termsContent = '';
  @Input() saveEmployees: boolean = false;
  @Input() validateCaseNumber: boolean = false;

  @ViewChild('LastName', { static: false }) nameField!: ElementRef;
  @ViewChild('inputFile', { static: false }) inputFile!: ElementRef;

  data: any;
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  payorChkType: any;

  validationType = '';

  prenoteEnum = PrenoteStatus;

  stepperOrientation: StepperOrientation = 'horizontal';

  termsFrmGp: FormGroup = new FormGroup({});
  bankFrmGp: FormGroup = new FormGroup({});
  reviewFrmGrp: FormGroup = new FormGroup({});

  paymentDetailFrmGp: FormGroup = new FormGroup({});
  paymentcollectionFrmGp: FormGroup = new FormGroup({});

  paymentaccountheader: string[] = [
    'Select',
    'Name',
    'Type',
    'Account',
    'Status',
  ];

  paymentaccounts: IPaymentAccount[];
  selectedPaymentAccount: IPaymentAccount = {} as IPaymentAccount;
  payment: IEMPPayment = {} as IEMPPayment;
  editpayment: IEMPPayment = {} as IEMPPayment;
  paymentCollection: IEMPPaymentCollection[];

  scheduledFrequencies: IScheduledFrequency[];
  scheduledDaysWeek: IScheduledDay[];
  scheduledDaysBiMonth: IScheduledDay[];
  scheduledDaysMonth: IScheduledDay[];
  scheduledDays: IScheduledDay[];
  scheduledpayments: IEMPPaymentList[] = [];

  today = new Date();
  maxDate = new Date();
  minDate = new Date();
  startDate = '';
  editPaymentStartDate!: IMyDateModel;
  fileImported = false;
  isFileValid = false;
  showPaymentCollectionForm = false;
  numOfPayments = 0;
  totalAmtOfPayments = 0;
  paymentsValid = false;
  numInvalid = 0;
  numWarning = 0;
  isValdiatingPayment = false;
  isEditPayment = false;
  isEditPaymentCollection = false;
  editPaymentCollectionIndex = 0;
  errorMessage = '';
  validationErrorMessage = '';
  showScheduleDay = false;
  selectedFrequency = '';
  selectedFrequencyCode = '';
  selectedDay = '';
  selectedDayCode = '';
  nextScheduledDate = '';
  noPreviousPayors = '';
  isLoadingPreviousPayors = false;
  isLoadingNextScheduledDate = false;
  isLoadingStartDate = false;
  isLoadingAccounts = false;

  frequencyCtrl: any;
  scheduleddayCtrl: any;

  confirmationSender = '';
  confirmationTitle = '';
  confirmationMessage = '';
  confirmationNumber = '';
  goToPrimary = '';
  goToPrimaryUrl = '';
  openConfirmation = false;
  isLoadingEdit = false;
  isTermsSubmitted = false;
  allChecked = false;

  ssnHide = true;

  animateInput = false;
  atLeastOnePayorSelected = false;
  validateAttemptMade = false;
  insertUpdateError = false;
  nameChangeOccured = false;
  insertUpdateErrorMessage = '';
  isBankAccountSelected = false;

  calendarHint = '';

  ariaLabel = 'Bank Account Select';

  toggleEditPayor = false;
  createPaymentButtonText = '';
  disableCreatePaymentButton: boolean = false;

  currencyPattern = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
  ssnPattern = /^(?!000|666)[0-9]{3}([ -]?)(?!00)[0-9]{2}\1(?!0000)[0-9]{4}$/;

  // Datepicker settings
  dateSettingsOptions: IAngularMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    firstDayOfWeek: 'su',
    closeSelectorOnDateSelect: true,
    sunHighlight: false,
    disableWeekends: true,
    disableUntil: {
      year: 0,
      month: 0,
      day: 0,
    },
  };

  constructor(
    private formbuilder: FormBuilder,
    private paymentService: PaymentService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    public dialog: MatDialog,
    private validDatePipe: ValidDatePipe,
    public snackbar: MatSnackBar,
    private viewpointService: ViewportService,
    public tooltip: MatTooltipModule
  ) {
    this.createPaymentButtonText = 'Create Payment';
    this.fileImported = false;
    this.isFileValid = false;
    this.paymentsValid = false;
    this.isEditPaymentCollection = false;
    this.showPaymentCollectionForm = false;
    this.isValdiatingPayment = false;
    this.showScheduleDay = false;
    this.paymentCollection = [];
    this.paymentaccounts = [];
    this.scheduledDaysWeek = [];
    this.scheduledDaysBiMonth = [];
    this.scheduledDaysMonth = [];
    this.scheduledDays = [];
    this.scheduledFrequencies = [];
    this.editPaymentCollectionIndex = -1;
    this.maxDate.setDate(
      this.today.getDate() + +CommonSettings.NumOfDaysOutForCalendar
    );
  }

  ngOnInit() {
    this.validationType = PayorValidationTypes.scheduldedPayment;
    this.loadFormGroups();
    this.getScheduledFrequency();
    this.getScheduledDays();

    this.viewpointService.StepperOrient.subscribe(
      (orient) => (this.stepperOrientation = orient)
    );

    this.frequencyCtrl = this.paymentDetailFrmGp.get('frequency');
    this.scheduleddayCtrl = this.paymentDetailFrmGp.get('scheduledday');

    this.frequencyCtrl!.valueChanges.subscribe((frequency: any) => {
      if (!this.isLoadingEdit) {
        this.changeDays(frequency);
        this.paymentDetailFrmGp.patchValue({
          startday: null,
        });
      }
    });

    this.scheduleddayCtrl!.valueChanges.subscribe((day: any) => {
      if (!this.isLoadingEdit) {
        if (day !== null && day !== undefined) {
          this.scheduledDays.forEach((whatday) => {
            if (whatday.scheduleDay === day) {
              this.selectedDay = whatday.scheduleDayName;
              this.selectedDayCode = whatday.scheduleDay;
              this.paymentDetailFrmGp.patchValue({
                startday: null,
              });
            }
          });
        }
      }
    });

    this.isLoadingAccounts = true;
    this.paymentService.getPaymentAccounts(this.baseurl).subscribe({
      next: (accounts: any) => {
        this.paymentaccounts = this.filterOldAccount(accounts);
      },
      error: (error: any) => {
        this.isLoadingAccounts = false;
        this.logError(error);
        this.handleError(error.status);
      },
      complete: () => {
        this.editpayment = history.state;
        if (this.editpayment.participantCollection !== undefined) {
          this.loadEditPayment();
        } else if (history.state !== null && history.state !== undefined) {
          this.paymentaccounts.forEach((account) => {
            if (
              account.scheduledPaymentAccountKey ===
                this.editpayment.scheduledPaymentAccountKey ||
              this.paymentaccounts.length === 1
            ) {
              account.isSelected = true;
              this.isBankAccountSelected = true;
              this.setEarliestStartDate(account.scheduledPaymentAccountKey);
              this.bankFrmGp.patchValue({
                bankName: account.bankName,
                accountType: account.accountType,
                accountTypeName: account.accountTypeName,
                maskedAccount: account.accountNumberMasked,
                accountKeyselected: account.scheduledPaymentAccountKey,
                isAccountSelected: true,
              });
              this.selectedPaymentAccount = account;
            } else {
              account.isSelected = false;
            }
          });
        }
      },
    });
    this.isLoadingAccounts = false;
  }

  toggleSSNHide() {
    this.ssnHide = !this.ssnHide;
  }

  filterOldAccount(accounts: IPaymentAccount[]) {
    return accounts.filter((account) => this.isAccountActive(account.inactiveDate));
  }

  isAccountActive(inactiveDate: any): boolean {
    // Accounts that were never inactivated should be treated as active,
    // even if inactiveDate comes back null/undefined instead of the
    // '9999-12-31' sentinel. Comparing the raw string (instead of running
    // it through DatePipe) also avoids a timezone conversion shifting the
    // sentinel date across the day boundary.
    if (!inactiveDate) {
      return true;
    }
    return inactiveDate.toString().slice(0, 10) === '9999-12-31';
  }

  loadEditPayment() {
    this.isEditPayment = true;
    this.isLoadingEdit = true;
    this.createPaymentButtonText = 'Save Payment Update';
    this.paymentCollection = this.editpayment.participantCollection;

    // Convert amount to number
    this.paymentCollection.forEach((payor) => {
      payor.amount = +payor.amount;
      payor.caseNumber = payor.secondaryId;
    });

    this.selectedFrequencyCode = this.editpayment.scheduleFrequency;
    this.changeDays(this.selectedFrequencyCode);
    this.selectedFrequency = this.editpayment.scheduleFrequencyText;
    this.selectedDayCode = this.editpayment.scheduleDay;
    this.selectedDay = this.editpayment.scheduleDayText;
    this.selectedPaymentAccount = {} as IPaymentAccount;
    this.paymentaccounts.forEach((account) => {
      if (
        account.scheduledPaymentAccountKey ===
        this.editpayment.scheduledPaymentAccountKey
      ) {
        this.selectedPaymentAccount = { ...account };
        account.isSelected = true;
        this.isBankAccountSelected = true;
      }
    });

    if (this.selectedPaymentAccount !== null) {
      this.selectedPaymentAccount.isSelected = true;
      this.bankFrmGp.setValue({
        isAccountSelected: true,
      });
      this.bankFrmGp.updateValueAndValidity();
      this.setEarliestStartDate(
        this.selectedPaymentAccount.scheduledPaymentAccountKey
      );

      this.paymentDetailFrmGp.patchValue({
        nickname: this.editpayment.scheduleNickName,
        frequency: this.editpayment.scheduleFrequency,
        scheduledday: this.editpayment.scheduleDay,
      });

      if (this.editpayment.scheduleDay !== '') {
        this.showScheduleDay = true;
      }
      this.selectedFrequencyCode = this.editpayment.scheduleFrequency;
      this.selectedDayCode = this.editpayment.scheduleDay;
      this.paymentCollection.forEach((payment) => {
        payment.isSelected = true;
        payment.isValidated = false;
        payment.hasError = false;
      });

      this.allChecked = true;
      this.isLoadingEdit = false;
    }
  }

  insertUpdatePayment() {
    this.disableCreatePaymentButton = true;
    this.createPaymentButtonText = 'Processing...';
    const payColl: IEMPPaymentCollection[] = [];
    this.paymentCollection.forEach((coll) => {
      if (coll.isSelected) {
        payColl.push(coll);
      }
    });

    this.payment = {
      batchType: 'WEB',
      payerType: 'EMP',
      scheduledPaymentAccountKey:
        this.selectedPaymentAccount.scheduledPaymentAccountKey,
      amount: this.totalAmtOfPayments,
      scheduleNickName: this.paymentDetailFrmGp.get('nickname')!.value,
      scheduleFrequency: this.selectedFrequencyCode,
      scheduleFrequencyText: this.selectedFrequency,
      scheduleDay: this.selectedDayCode,
      scheduleDayText: this.selectedDay,
      scheduleStartDate: this.startDate,
      scheduleEndDate: '9999-12-31',
      nextScheduledDate: this.nextScheduledDate,
      schedulePaymentId: this.isEditPayment
        ? this.editpayment.schedulePaymentId
        : -1,
      participantCollection: payColl,
      confirmDuplicatePayment: this.isEditPayment ? true : false,
      saveEmployees: this.saveEmployees,
    };

    this.paymentService
      .insertUpdateEMPPayment(
        this.baseurl,
        this.validateCaseNumber,
        this.payment
      )
      .subscribe({
        next: (confirm: any) => {
          this.insertUpdateError = false;
          this.insertUpdateErrorMessage = '';
          this.onSaveComplete(confirm.confirmationNumber);
        },
        error: (error: any) => {
          if (error.status === 400) {
            this.createPaymentButtonText = this.isEditPayment
              ? 'Save Payment'
              : 'Create Payment';
            this.disableCreatePaymentButton = false;
            this.insertUpdateError = true;
            this.insertUpdateErrorMessage = error.error.failureMessage;
          }
          if (error.status === 409) {
            console.log(error);
            this.createPaymentButtonText = this.isEditPayment
              ? 'Save Payment'
              : 'Create Payment';
            this.disableCreatePaymentButton = false;
            this.insertUpdateError = false;
            this.insertUpdateErrorMessage = '';
            this.confirmDuplicatePayment(this.payment, error.error);
          } else {
            this.logError(error);
            this.handleError(error.status);
          }
        },
      });
  }

  confirmDuplicatePayment(payment: IEMPPayment, errorMsg: string) {
    let confirmResult = false;
    const message = errorMsg;
    const action =
      'Select YES to continue to create a duplicate payment or select NO to cancel';
    const dialogData = new ConfirmDialogModel(
      'Confirm Creating Duplicate Scheduled Payment',
      message,
      action,
      '',
      '',
      '',
      ''
    );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '900px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe({
      next: (dialogResult: any) => (confirmResult = dialogResult),
      error: (error: any) => console.log(error),
      complete: () => {
        if (confirmResult) {
          this.createPaymentButtonText = 'Processing...';
          this.disableCreatePaymentButton = true;
          payment.confirmDuplicatePayment = true;
          this.paymentService
            .insertUpdateEMPPayment(
              this.baseurl,
              this.validateCaseNumber,
              payment
            )
            .subscribe({
              next: (confirm: any) => {
                this.onSaveComplete(confirm.confirmationNumber);
              },
              error: (error: any) => {
                if (error.status === 400) {
                  this.insertUpdateError = true;
                  this.insertUpdateErrorMessage = error.error.failureMessage;
                } else {
                  this.logError(error);
                  this.handleError(error.status);
                }
              },
            });
        } else {
          this.goToACHDLanding();
        }
      },
    });
  }

  validPayorCollectionEmitted(payors: any) {
    this.paymentCollection = payors.payorCollection;
    this.getNumberOfPayments();
  }

  addRemoveAccount(event: any, index: number, account: IPaymentAccount) {
    this.isBankAccountSelected = false;
    this.paymentaccounts.forEach((acct) => {
      acct.isSelected = false;
    });
    if (event.target.checked) {
      this.paymentaccounts[index].isSelected = true;
      this.selectedPaymentAccount = account;
      this.isBankAccountSelected = true;
      this.bankFrmGp.patchValue({
        isAccountSelected: true,
      });
      this.setEarliestStartDate(
        this.paymentaccounts[index].scheduledPaymentAccountKey
      );
    } else {
      this.paymentaccounts[index].isSelected = false;
      this.isBankAccountSelected = false;
      this.bankFrmGp.reset();
      this.calendarHint = '';
    }
  }

  addPayorDetail() {}

  getNumberOfPayments(): number {
    this.numOfPayments = 0;
    this.totalAmtOfPayments = 0;
    this.atLeastOnePayorSelected = false;
    this.paymentCollection.forEach((element) => {
      if (element.isSelected) {
        this.atLeastOnePayorSelected = true;
        this.numOfPayments++;
        this.totalAmtOfPayments += +element.amount;
      }
    });
    this.totalAmtOfPayments = +this.totalAmtOfPayments.toFixed(2);
    return this.numOfPayments;
  }

  setEarliestStartDate(accountkey: string) {
    this.paymentService
      .getEarliestStartDate(this.baseurl, accountkey)
      .subscribe({
        next: (result: any) => {
          this.minDate = new Date(
            this.validDatePipe.transform(result.earliestDate)
          );
          this.calendarHint =
            'New payments for selected bank account can be scheduled starting on ' +
            this.minDate.toDateString() +
            '.';
          this.setDateUntilOption();
        },
        error: (error: any) => {
          this.logError(error);
          this.handleError(error.status);
        },
      });
  }

  loadFormGroups() {
    this.termsFrmGp = this.formbuilder.group({
      accepted: ['', Validators.requiredTrue],
    });

    this.bankFrmGp = this.formbuilder.group({
      isAccountSelected: ['', Validators.requiredTrue],
      bankAcct: ['']
    });

    this.paymentDetailFrmGp = this.formbuilder.group({
      nickname: ['', Validators.maxLength(40)],
      frequency: ['', Validators.required],
      scheduledday: '',
      startday: [null, Validators.required],
    });

    this.reviewFrmGrp = this.formbuilder.group({});
  }

  resetFormValues() {
    this.termsFrmGp.setValue({
      accepted: false,
    });
    this.bankFrmGp.setValue({
      isAccountSelected: false,
    });
    // this.paymentFrmGp.setValue({
    //   filename: ' Choose File',
    //   collectionFrmGp: {
    //     lastname: '',
    //     ssn: '',
    //     casenumber: '',
    //     amount: '',
    //   },
    //   isValid: false,
    // });
    this.paymentDetailFrmGp.setValue({
      nickname: '',
      frequency: '',
      scheduledday: '',
      startday: null,
    });
  }

  checkReading() {}

  changeDays(frequency: string) {
    let whatfreq: any;
    this.scheduledFrequencies.forEach((freq) => {
      if (freq.scheduleFrequency === frequency) {
        whatfreq = freq;
      }
    });
    if (whatfreq !== undefined) {
      switch (whatfreq.scheduleFrequency) {
        case 'WKL': {
          this.scheduledDays = this.scheduledDaysWeek;
          this.setScheduledDay(whatfreq);
          this.selectedFrequencyCode = whatfreq.scheduleFrequency;
          this.selectedFrequency = whatfreq.scheduleFrequencyName;
          this.showScheduleDay = true;
          break;
        }
        case 'BIW': {
          this.scheduledDays = this.scheduledDaysWeek;
          this.setScheduledDay(whatfreq);
          this.selectedFrequencyCode = whatfreq.scheduleFrequency;
          this.selectedFrequency = whatfreq.scheduleFrequencyName;
          this.showScheduleDay = true;
          break;
        }
        case 'SEM': {
          this.scheduledDays = this.scheduledDaysBiMonth;
          this.setScheduledDay(whatfreq);
          this.selectedFrequencyCode = whatfreq.scheduleFrequency;
          this.selectedFrequency = whatfreq.scheduleFrequencyName;
          this.showScheduleDay = true;
          break;
        }
        case 'MON': {
          this.scheduledDays = this.scheduledDaysMonth;
          this.setScheduledDay(whatfreq);
          this.selectedFrequencyCode = whatfreq.scheduleFrequency;
          this.selectedFrequency = whatfreq.scheduleFrequencyName;
          this.showScheduleDay = true;
          break;
        }
        case 'NOR': {
          this.scheduleddayCtrl.setErrors(null);
          this.paymentDetailFrmGp.updateValueAndValidity();
          this.scheduledDays = [];
          this.showScheduleDay = false;
          this.selectedFrequencyCode = whatfreq.scheduleFrequency;
          this.selectedFrequency = whatfreq.scheduleFrequencyName;
          this.selectedDay = 'One Time';
          this.selectedDayCode = 'ONET';
          this.paymentDetailFrmGp.get('scheduledday')!.setErrors(null);
          break;
        }
      }
    }
  }

  setScheduledDay(frequency: IScheduledFrequency) {
    this.selectedDay = '';
    this.selectedDayCode = '';
    this.paymentDetailFrmGp.patchValue({
      scheduledday: '',
    });
    this.paymentDetailFrmGp
      .get('scheduledday')!
      .setValidators([Validators.required]);
    this.paymentDetailFrmGp.updateValueAndValidity();
    this.showScheduleDay = true;
  }

  getNextScheduledDate() {
    if (
      this.paymentDetailFrmGp.get('startday')!.value !== null &&
      this.paymentDetailFrmGp.get('startday')!.value !== undefined
    ) {
      const startDayCvt = this.paymentDetailFrmGp.get('startday')!.value;

      this.isLoadingNextScheduledDate = true;
      if (this.selectedDayCode !== '' && this.selectedDayCode !== null) {
        this.paymentService
          .getNextScheduledPaymentDate(
            this.baseurl,
            startDayCvt,
            this.selectedFrequencyCode,
            this.selectedDayCode
          )
          .subscribe({
            next: (result: any) => {
              this.nextScheduledDate = result.nextScheduledDate.substr(0, 10);
            },
            error: (error: any) => {
              this.errorMessage = error as any;
              this.isLoadingNextScheduledDate = false;
            },
          });
      }
      this.isLoadingNextScheduledDate = false;
    }
  }

  onSaveComplete(confirmationNum: string) {
    this.paymentDetailFrmGp.reset();
    //this.paymentFrmGp.reset();
    this.termsFrmGp.reset();
    this.bankFrmGp.reset();
    this.reviewFrmGrp.reset();

    this.confirmationSender = 'Create A New Payment';
    this.confirmationTitle = 'Success';
    this.confirmationMessage = this.isEditPayment
      ? 'Your scheduled payment has been updated!'
      : 'New scheduled payment has been created!';
    this.confirmationNumber = confirmationNum;
    this.goToPrimaryUrl = 'employer/achd/landing';
    this.goToPrimary = 'ACH Debit Home';
    this.openConfirmation = true;
  }

  hideConfirmationPage() {
    window.location.reload();
  }

  getScheduledFrequency() {
    this.paymentService.getScheduledFrequency(this.baseurl).subscribe({
      next: (result: any) => (this.scheduledFrequencies = result),
      error: (error: any) => (this.errorMessage = error as any),
    });
  }

  getScheduledDays() {
    this.paymentService.getScheduledDays(this.baseurl, '').subscribe({
      next: (result: any) => {
        this.scheduledDays = result;
        this.scheduledDaysWeek = result.slice(46, 51);
        this.scheduledDaysBiMonth = result.slice(31, 46);
        this.scheduledDaysMonth = result.slice(0, 31);
      },
      error: (error: any) => (this.errorMessage = error as any),
    });
  }

  getScheduledDaysForFrequency(freq: string) {
    this.paymentService.getScheduledDays(this.baseurl, freq).subscribe({
      next: (result: any) => (this.scheduledDays = result),
      error: (error: any) => (this.errorMessage = error as any),
    });
  }

  weekendFilter = (d: Date): boolean => {
    const day = d.getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  };

  goToPaymentAccount() {
    this.router.navigateByUrl('employer/achd/paymentaccounts');
  }

  goToACHDLanding() {
    this.router.navigateByUrl('employer/achd/landing');
  }

  openSnackBar(message: string, time: number, style: string) {
    const config = new MatSnackBarConfig();
    config.horizontalPosition = 'center';
    config.verticalPosition = 'top';
    config.duration = time;
    config.panelClass = style;
    this.snackbar.open(message, '', config);
  }

  submitTerms() {
    this.isTermsSubmitted = true;
  }

  test(event: any) {
    console.log("** ", this.paymentDetailFrmGp)
  }

  dateFormat(event: IMyDateModel): void {
    this.insertUpdateErrorMessage = '';
    this.insertUpdateError = false;

    this.startDate = event.singleDate?.formatted!;
    this.paymentDetailFrmGp.patchValue({
      startday: event.singleDate?.formatted,
    });
    this.getNextScheduledDate();
  }

  setDateUntilOption() {
    const copy = this.getCopyOfOptions();
    copy.disableUntil = {
      year: this.minDate.getFullYear(),
      month: this.minDate.getMonth() + 1,
      day:
        this.minDate.getDate() === 1
          ? this.minDate.getDate()
          : this.minDate.getDate() - 1,
    };
    copy.disableSince = {
      year: this.maxDate.getFullYear(),
      month: this.maxDate.getMonth() + 1,
      day: this.maxDate.getDate() + 1,
    };
    this.dateSettingsOptions = copy;
  }

  getCopyOfOptions() {
    return JSON.parse(JSON.stringify(this.dateSettingsOptions));
  }

  logError(error: Error) {
    this.errorHandlerService.logError(error);
  }

  handleError(error: number) {
    this.errorHandlerService.handleErrorMessage(error, this.baseurl);
  }
}
